export const SocketEvents = {
  PAYMENT: {
    APPROVED: 'payment/approved',
  },
	CHAT: {
		MESSAGE: 'chat_message'
	}
}